module.exports = __webpack_public_path__ + "static/media/totalPnts_750_1000.caf032aa.png";